export const GOOD_360_CREATE_DEFAULTS = {
	description: '',
	editorialDescription: '',
	relatedSameCategory: false,
	relatedSameTrend: false,
	relatedSameClaim: false,
	relatedSameCompany: false,
	relatedMax: 8,
};
